import { render, staticRenderFns } from "./PersonMain.vue?vue&type=template&id=670b4320&scoped=true&"
import script from "./PersonMain.vue?vue&type=script&lang=js&"
export * from "./PersonMain.vue?vue&type=script&lang=js&"
import style0 from "./PersonMain.vue?vue&type=style&index=0&id=670b4320&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b4320",
  null
  
)

export default component.exports